import { useEffect } from 'react';

const SITE_NAME = 'Sankyo Machine Tools';
const DEFAULT_DESCRIPTION = 'Sankyo Machine Tools Philippines Inc. — Precision Machinery & Measuring Equipment.';

function setMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
}

// One <script type="application/ld+json"> for structured data, replaced
// (not appended) on every call so navigating between pages never leaves a
// stale JSON-LD block from the previous page behind.
function setStructuredData(data) {
  const id = 'seo-structured-data';
  let script = document.getElementById(id);
  if (!data) {
    if (script) script.remove();
    return;
  }
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

// Sets the document title, meta description, canonical URL, and an optional
// JSON-LD structured-data block for the current page. No react-helmet
// dependency — this is a small enough surface (title + one meta tag + one
// script tag) to just own directly via useEffect.
export default function SEO({ title, description, structuredData }) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    setMeta('description', description || DEFAULT_DESCRIPTION);
    setCanonical(window.location.origin + window.location.pathname);
    setStructuredData(structuredData);
    // No cleanup: the next page's SEO call overwrites these on mount, and a
    // stale title/description for a fraction of a second during navigation
    // away is harmless — nothing reads it once the new page has rendered.
  }, [title, description, structuredData]);

  return null;
}
